import FJConstant from '../../constants/FJConstant';
import FJVideoPlayBase from '../../core/FJVideo/FJVideoPlayBase';
import FJCanvasUtil from '../../util/FJCanvasUtil';
import FJUtil from '../../util/FJUtil';
import FJPoolStore from '../FJPoolStore';

export const BACKGROUND_TYPE = {
    IMAGE: 'image',
    COLOR: 'color',
    TRANSPARENT: 'transparent',
};

class FJVideoRemoveBaseManage extends FJVideoPlayBase {
    _canvas = null; // 画布
    _ctx = null; // 画布上下文

    _backgroundCanvas = null;
    _backgroundCtx = null;

    _backgroundImage = null;
    _backgroundImageLoaded = false;
    _backgroundImageRect = null;

    _sourceFile = null; // 视频源文件

    _backgroundInfo = {
        type: BACKGROUND_TYPE.TRANSPARENT,
        imageInfo: null,
        color: null,
    };

    _transparentSize = 14;

    constructor() {
        super();
        this._backgroundCanvas = FJPoolStore.getCanvas();
        this._backgroundCtx = this._backgroundCanvas.getContext('2d');
    }
    /**
     * @desc 绘制画面
     */
    async draw() {
        if (this._loadStatus !== FJConstant.SUCCESS || !this._source || !this._ctx) return;

        this._canvas.width = this._sourceInfo.width;
        this._canvas.height = this._sourceInfo.height;

        const rect = {
            x: 0,
            y: 0,
            width: this._sourceInfo.width,
            height: this._sourceInfo.height,
        };

        super.draw(this._ctx, rect);
    }

    clearAll() {
        super.clearAll();
        this._sourceFile = null;
        this._backgroundInfo = {
            type: BACKGROUND_TYPE.TRANSPARENT,
            imageInfo: null,
            color: null,
        };
    }

    /**
     * @desc 设置画布
     * @param {Object} canvas
     */
    setCanvas(canvas) {
        this._canvas = canvas;
        this._ctx = canvas.getContext('2d');
    }

    updateBackgroundCanvas() {
        const size = this.getSize();
        if (!size) return;

        if (!this._backgroundCanvas) {
            this._backgroundCanvas = FJPoolStore.getCanvas('2d', true);
            this._backgroundCtx = this._backgroundCanvas.getContext('2d');
        }

        this._backgroundCanvas.width = size.width;
        this._backgroundCanvas.height = size.height;

        const { type, color } = this._backgroundInfo;

        switch (type) {
            case BACKGROUND_TYPE.TRANSPARENT: {
                const transparentSize = Math.round(
                    ((this._transparentSize / 1080) * size.width) / (size.width / size.height),
                );

                FJCanvasUtil.drawTransparentBackground(this._backgroundCtx, size.width, size.height, transparentSize);
                break;
            }
            case BACKGROUND_TYPE.COLOR: {
                this._backgroundCtx.save();
                this._backgroundCtx.fillStyle = color;
                this._backgroundCtx.fillRect(0, 0, size.width, size.height);
                this._backgroundCtx.restore();
                break;
            }
            case BACKGROUND_TYPE.IMAGE: {
                if (!this._backgroundImage) return;

                this._backgroundCtx.drawImage(
                    this._backgroundImage,
                    this._backgroundImageRect.x,
                    this._backgroundImageRect.y,
                    this._backgroundImageRect.width,
                    this._backgroundImageRect.height,
                );
                break;
            }
        }
    }

    getBackgroundInfo() {
        return this._backgroundInfo;
    }

    _fitBackgroundImage() {
        if (!this._backgroundImage) return;

        const size = this.getSize();
        const bgSize = {
            width: this._backgroundImage.width,
            height: this._backgroundImage.height,
        };

        const canvasAspect = size.width / size.height;
        const imageAspect = bgSize.width / bgSize.height;

        if (canvasAspect < imageAspect) {
            bgSize.height = size.height;
            bgSize.width = size.height * imageAspect;
        } else {
            bgSize.width = size.width;
            bgSize.height = size.width / imageAspect;
        }

        this._backgroundImageRect = {
            x: (size.width - bgSize.width) / 2,
            y: (size.height - bgSize.height) / 2,
            width: bgSize.width,
            height: bgSize.height,
        };
    }

    async setBackgroundImage(setBackgroundImage) {
        let backgroundImageUrl = setBackgroundImage.url;

        const isCrossOrigin = FJUtil.isCrossOrigin(backgroundImageUrl);

        if (isCrossOrigin) {
            // 下载图片
            backgroundImageUrl = await FJUtil.getBlobByUrlSolveCrossOrigin(backgroundImageUrl);
        }
        try {
            await new Promise((resolve, reject) => {
                // 判断editImageUrl 是否跨域
                this._backgroundImage = new Image();
                this._backgroundImage.src = backgroundImageUrl;

                this._backgroundImage.onload = () => {
                    this._backgroundImageLoaded = true;
                    resolve();
                };

                this._backgroundImage.onerror = () => {
                    reject();
                };
            });

            this._fitBackgroundImage();
            this._backgroundInfo.type = BACKGROUND_TYPE.IMAGE;
            this._backgroundInfo.imageInfo = setBackgroundImage;
            this._backgroundInfo.color = null;
            this.updateBackgroundCanvas();
        } catch (error) {
            this._backgroundImageLoaded = false;
            this._backgroundImage = null;
            throw error;
        }
    }

    setBackgroundColor(color) {
        this._backgroundInfo.type = BACKGROUND_TYPE.COLOR;
        this._backgroundInfo.color = color;
        this._backgroundInfo.imageInfo = null;
        this.updateBackgroundCanvas();
    }

    clearBackground() {
        this._backgroundInfo.type = BACKGROUND_TYPE.TRANSPARENT;
        this._backgroundInfo.color = null;
        this._backgroundInfo.imageInfo = null;
        this.updateBackgroundCanvas();
    }

    /**
     * @desc 获取视频源
     * @returns {Object}
     */
    getSource() {
        return this._sourceFile;
    }

    /**
     * @desc 跳转到指定帧
     * @param {Number} time
     */
    async seek(time, notDraw = false) {
        if (!this._source) return;
        const seeked = await new Promise(resolve => {
            this._source.removeEventListener('seeked', this._seekedListener);

            this._seekedListener = () => {
                resolve && resolve(true);
            };
            this._source.addEventListener('seeked', this._seekedListener);

            this._source.currentTime = time;
        });

        if (seeked) {
            !notDraw && this.draw();
        }
    }
}
export default FJVideoRemoveBaseManage;
